// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  env: "mapix_test",
  appName: "Mapix",
  production: false,
  mapBoxToken:
    "pk.eyJ1IjoiZGFueWVsZ3R6IiwiYSI6ImNqeHY1cnJwejAxaGMzZm9jOXk4bWQ1MWYifQ.erh4k45vOrbGIpdT12F-ZA",
  googleMapsApiKey: "AIzaSyA55wRJgqVJIQkjdXH47vW-Epb4mnWmCkQ",
  botDirectLineKey:
    "DWPCUBB2uixcl2m0CTAaAvEqVEwGsxsyIZbvva4LUbgM1EdVxYzkJQQJ99BEACYeBjFAArohAAABAZBS1D4x.C7FEgl0fmmHDvZPJ2O9tWe0SXyqyo9PAbfxqMo7sKWuaZPo31nqgJQQJ99BEACYeBjFAArohAAABAZBS2Liz",
  unileverDummyUrl:
    "https://unilever.dev.einteligent.com/WebServices",
  host: "https://mapixapi.test.einteligent.com",
  signalRHost: "https://mapix-incommings-test.azurewebsites.net",

  sentry: {
    dsn: 'https://5a7c8fb76a4b50f68382c3443212f320@o4511140374249472.ingest.us.sentry.io/4511140393975808',
    tracesSampleRate: 1,
    sampleRate: 1,
    environment: 'test'
  }
};


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
